import { render, staticRenderFns } from "./LayoutManager.vue?vue&type=template&id=a2f03aa0&"
import script from "./LayoutManager.vue?vue&type=script&lang=js&"
export * from "./LayoutManager.vue?vue&type=script&lang=js&"
import style0 from "./LayoutManager.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports